import type { ReactNode } from "react";

/** A short list of facts for a preview or confirm step: label on the left, value on the right (stacks on a phone). */
export function Facts({ rows }: { rows: [string, ReactNode][] }) {
  const shown = rows.filter(([, v]) => v !== undefined && v !== null && v !== "");
  if (shown.length === 0) return null;
  return (
    <dl className="grid grid-cols-1 gap-x-4 gap-y-1 text-sm sm:grid-cols-[auto_minmax(0,1fr)]">
      {shown.map(([k, v]) => (
        <div key={k} className="contents">
          <dt className="text-[var(--color-muted-foreground)]">{k}</dt>
          <dd className="mb-1 min-w-0 break-words font-medium sm:mb-0">{v}</dd>
        </div>
      ))}
    </dl>
  );
}

/** A server error or a refusal, said plainly where the person is looking. */
export function Problem({ text }: { text: string }) {
  if (!text) return null;
  return (
    <p role="alert" className="rounded-md bg-[var(--color-danger-bg)] px-3 py-2 text-sm text-[var(--color-danger-fg)]">
      {text}
    </p>
  );
}

/** The server's own sentence about what a confirm does. */
export function ServerSays({ text }: { text: string }) {
  if (!text) return null;
  return <p className="rounded-md bg-[var(--color-warning-bg)] px-3 py-2 text-sm text-[var(--color-warning-fg)]">{text}</p>;
}
